import { useMutation } from '@tanstack/react-query';
import { apiClient } from '../apiClient';
import { getQueryKeyBase, MUTATION_KEYS } from '../queryClient';
import { updateCacheArray, CACHE_ACTIONS } from '../cacheClient';
import { getQueryKey } from './useSecuritySchemes';

// Config
import { uiConfig } from '../../../conf/securitySchemes';

export const getMutationKey = getQueryKeyBase.bind(null, MUTATION_KEYS.SECURITY_SCHEME);

export const useDeleteScheme = ({ crudConfig, sessionToken, onSuccessCb, onErrorCb }) => {
    const Client = apiClient(crudConfig);

    return useMutation({
        mutationKey: getMutationKey(),
        mutationFn: (schemeId) => Client.delete(sessionToken, schemeId),
        onSuccess: (data) => {
            updateCacheArray({
                queryKey: getQueryKey(),
                action: CACHE_ACTIONS.REMOVE,
                primaryKey: uiConfig.primaryKey,
                data
            });
            onSuccessCb?.();
        },
        onError: (error) => {
            console.log('Error', error);
            onErrorCb?.(error);
        },
        refetchOnWindowFocus: false
    });
};
